export default "__VITE_ASSET__3c386275__"